import React, { useState } from 'react';
import DownloadableReportTable from '../DownloadableReportTable';
import { getService } from '@Client/runner.hooks/useService';
import KendoReactDatePicker from '@Shared.Angular/kendo.react/KendoReactDatePicker';

const UserReportsTab = () => {
  const APP_CONFIG = getService('APP_CONFIG');
  const momentService = getService('momentService');

  const [userFromDate, setUserFromDate] = useState<Date>(
    momentService().subtract('months', 1).toDate()
  );
  const [userToDate, setUserToDate] = useState<Date>(momentService().toDate());

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const reports = [
    {
      name: 'Users Report',
      description: 'Basic information about users and logins.',
      url: APP_CONFIG.apiBaseUrl + 'reports/users/current/csvV2',
      parameters: {
        userTimeZone: userTimeZone,
        fromDate: momentService(userFromDate).format(
          'YYYY-MM-DDTHH:mm:ss.SSSZ'
        ),
        toDate: momentService(userToDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ')
      }
    }
  ];
  return (
    <>
      <link
        href="https://kendo.cdn.telerik.com/themes/7.0.1/material/material-main.css"
        rel="stylesheet"
        type="text/css"
      />
      <div className="user-reports">
        <div className="user-reports-toolbar">
          <KendoReactDatePicker
            format={'dd/MM/yyyy'}
            value={userFromDate}
            onChange={(event) => setUserFromDate(event.value)}
          />
          <span className="date-spacer"> To </span>
          <KendoReactDatePicker
            format={'dd/MM/yyyy'}
            value={userToDate}
            onChange={(event) => setUserToDate(event.value)}
          />
        </div>
        <DownloadableReportTable reports={reports} />
      </div>
    </>
  );
};

export default UserReportsTab;
